export default __webpack_public_path__ + "static/media/Trombone.b7ea779a.png";